(function($){
  var deviceSP = OH.browserInfo.isiOS || OH.browserInfo.isAndroid;
  var deviceSPMediaQuery = window.matchMedia('(max-width:600px)').matches;
  OH.settings.topText = (function(){
    var control = new Object();

    /**
     * 1行ずつの出し分け
     * @type {Object} $thisElement 指定dom
     * @type {Object} $indexElement 同じクラス名の数
     * @type {Number} 画面上での順番か出すときのディレイ調整
     */
    control.oneLineUp = function($thisElement,$indexElement,orderNum){
      var pcKvOffset = $thisElement.parents('a.mainVisual__pc__item').find('.mainVisual__pc__item__img').offset(); 
      var spKvOffset = $thisElement.parents('a.mainVisual__sp__item').find('.mainVisual__sp__item__img').offset(); 
      var kvOffset = deviceSPMediaQuery ? spKvOffset.left : pcKvOffset.left;
      //  console.log(kvOffset);
       var indexNum = $indexElement.index($thisElement);
       var thisIndexNum = indexNum + orderNum;
      //  console.log(atfirst);
      //  console.log($thisElement.parent(),thisIndexNum,indexNum , orderNum);
       var delayTime = 200 * thisIndexNum;
       //init 
       $thisElement.css({
         transform: 'translate(0,100%)'
       });
       $thisElement.stop(true,true).delay(delayTime).animate({
         zIndex: 1
       },{
         duration: 1200,
         easing: 'easeInOutCubic',//easing セッティング
         step: function(flame){
           $thisElement.css({
             transform: 'translate(0,'+ (100 - flame * 100) + '%)'
           });
         },
         complete: function(){
          //  $indexElement.css('transform','translate(0,0)');
           $thisElement.css('zIndex',0);
         }
       });
    };
  
    control.hideAnimation = function($thisElement,$indexElement,orderNum){
      $thisElement.stop(true,true).css({
        transform: 'translate(0, -100%)'
        // ,
        // complete: function(){
        //   atfirst = true;
        // }
        });
    };
    return control;
  })();
})(jQuery);
